export const HUBSPOT_DEMO_CALL_URL = 'https://eo9t.share.hsforms.com/2Cw8yvadmRzu-iIwW18NCgg';

export const HUBSPOT_DEMO_CALL_ID = '0b0f32bd-a766-473b-be88-8c16d7c34282';

export const HUBSPOT_MEETINGS_URL = 'https://meetings.hubspot.com';

export const HUBSPOT_DEMO_CALENDAR_SLUGS: Partial<Record<string, string>> = {
  fr: 'sortlist/demo-fr',
  nl: 'sortlist/demo-nl',
  de: 'sortlist/demo-de',
  es: 'sortlist/demo-es',
  it: 'sortlist/demo-it',
};
